import { useTranslation } from 'react-i18next'
import { BaseQuestionRendererProps, TextAnswer } from './types'
import { ChartWrapper, ChartEmptyState } from './shared'

export function LongTextRecentList({ question }: BaseQuestionRendererProps) {
  const { t } = useTranslation()
  const textAnswers = question.answers
    .filter((answer): answer is TextAnswer => 'submittedAt' in answer)
    .slice(0, 3)

  if (textAnswers.length === 0) {
    return (
      <ChartWrapper
        title={question.label}
        description={t('dashboard.charts.recent_responses_last_3')}
      >
        <ChartEmptyState
          message={t('dashboard.charts.no_responses_yet')}
        />
      </ChartWrapper>
    )
  }

  return (
    <ChartWrapper
      title={question.label}
      description={t('dashboard.charts.recent_responses_showing', {
        showing: textAnswers.length,
        total: question.totalRespondents || 0,
      })}
    >
      <div className="space-y-4 w-full shadow-sm rounded-lg p-2 overflow-auto">
        {textAnswers.map((answer, index) => (
          <div key={index} className="border-l-2 border-[#72DD68] pl-3">
            <div className="text-sm">{answer.value}</div>
            <div className="text-xs text-muted-foreground mt-1 border-t pt-2 text-[gray-50">
              {t('dashboard.charts.submitted_on', {
                date: new Date(answer.submittedAt).toLocaleDateString(),
              })}
            </div>
          </div>
        ))}
      </div>
    </ChartWrapper>
  )
}
